import { YaPaySdk } from "~/types/yaPay";
import { loadScript } from "./script";

declare var YaPay: YaPaySdk.YaPay | undefined;

export class YandexPayController {

    private resolvers: ((v: void) => void)[] = [];
    private loading = false;
    private inited = false;

    private static instance: YandexPayController | null = null;

    private load() {
        if (!this.inited) {

            if (!this.loading) {
                this.loading = true;
                loadScript('https://pay.yandex.ru/sdk/v1/pay.js')
                    .then(() => {
                        this.inited = true;
                        this.resolvers.forEach((el) => el());
                    });
            }

            return new Promise<void>((resolve) => {
                this.resolvers.push(resolve);
            });
        }

        return new Promise<void>((resolve) => {
            resolve();
        });
    }

    public async createSession(money: number, checkout: () => any = null) {
        if (!YaPay) {
            return null;
        }

        return await YaPay.createSession({
            availablePaymentMethods: ['SPLIT'],
            env: 'PRODUCTION',
            currencyCode: 'RUB',
            merchantId: '8480cbf0-58df-4fe3-8b17-9cb8b9f9cb26',
            totalAmount: money.toFixed(2),
            version: 4
        }, {
            onFormOpenError: () => {

            },
            onPayButtonClick: checkout ?? (() => {}),
        });
    }

    public static async getInstance() {
        if (!this.instance) {
            this.instance = new YandexPayController();
        }

        if (!this.instance.inited) {
            await this.instance.load();
        }

        return this.instance;
    }
};
